import { memo, useCallback, useEffect, useState } from 'react';
import NextImage from 'next/image';
import NextLink from 'next/link';
// @ts-expect-error (@tawk.to/tawk-messenger-react does not have ts support)
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

import { Container } from '../common/container';
import { HeaderActions, HeaderLogo, HeaderWrapper } from './styles';
import Text from '../common/text';
import { useWindow, useWindowScroll } from 'hooks/useWindow';
// import Burger from "../common/Burger";
import HeaderNavigation from './HeaderNavigation';
import HeaderNavigationMobile from './HeaderNavigationMobile';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import HeaderAccount from './HeaderAccount';
import { toggleMobileNav } from 'store/slices/global';
import HeaderBottomBlock from './HeaderBottomBlock';
import { HOME_VALUATION_ROUTE } from 'constants/routes';
import { userSelector } from 'store/slices/auth/selector';
import useTriggerFunnelyticsEvent from 'hooks/useTriggerFunnelyticsEvent';
import {
  GENERIC_EVENTS,
  HOME_VALUATION_EVENTS,
} from 'hooks/useTriggerFunnelyticsEvent/constants';

function Header({ transparentHeader }: HeaderProps) {
  const { w } = useWindow();
  const { createEventTriggerer } = useTriggerFunnelyticsEvent();
  const { jwt } = useAppSelector(userSelector);
  const dispatch = useAppDispatch();

  const openMobileMenu = useCallback(() => {
    dispatch(toggleMobileNav());
  }, [dispatch]);

  const { scrollTop } = useWindowScroll();
  const [whiteHeader, setWhiteHeader] = useState(false);

  useEffect(() => {
    if (scrollTop >= 100) {
      setWhiteHeader(true);
    } else {
      setWhiteHeader(false);
    }
  }, [scrollTop]);

  function getIconName() {
    if (whiteHeader || transparentHeader) {
      return 'burger-colored';
    }

    return 'burger';
  }

  return (
    <>
      <HeaderWrapper
        whiteHeader={whiteHeader}
        transparentHeader={transparentHeader}
      >
        <Container size="xl">
          <NextLink href="/" passHref>
            <HeaderLogo className="header-logo">
              <NextImage
                src={`/static/${
                  !whiteHeader ? `logo-richr-new` : `logo-richr-new-colored`
                }.svg`}
                width={w <= 1280 ? 112 : 132}
                height={w <= 1280 ? 38 : 44}
                priority
                quality={100}
              />
            </HeaderLogo>
          </NextLink>

          {w > 1280 && <HeaderNavigation />}

          <HeaderActions>
            {w > 1280 && (
              <>
                <a
                  href="tel:+18449574247"
                  className="header-phone"
                  onClick={createEventTriggerer({
                    eventName: GENERIC_EVENTS.CALL_EXPERT,
                    withPathname: true,
                    ctaPosition: 'nav-bar',
                  })}
                >
                  <Text fw="bold">+1844-957-4247</Text>
                </a>
                <NextLink href={HOME_VALUATION_ROUTE} passHref>
                  <a
                    className="header-valuation"
                    onClick={createEventTriggerer({
                      eventName: HOME_VALUATION_EVENTS.START,
                      withPathname: true,
                      ctaPosition: 'nav-bar',
                    })}
                  >
                    <Text fw="bold">Get My Free Home Valuation</Text>
                  </a>
                </NextLink>
                {jwt && <HeaderAccount />}
              </>
            )}

            {/* {w <= 1280 && <Burger />} */}
            {w <= 1280 && (
              <>
                {jwt && <HeaderAccount />}

                <button
                  type="button"
                  onClick={openMobileMenu}
                  className="header-burger"
                >
                  <NextImage
                    src={`/static/icons/${getIconName()}.svg`}
                    width={32}
                    height={32}
                    alt="Burger Icon"
                  />
                </button>
              </>
            )}
          </HeaderActions>
        </Container>
        {w <= 1280 && <HeaderNavigationMobile />}
      </HeaderWrapper>
      {w <= 480 && <HeaderBottomBlock />}

      {w <= 480 && (
        <TawkMessengerReact
          propertyId="5ec6e7c0c75cbf1769ee3345"
          widgetId="default"
        />
      )}
    </>
  );
}

interface HeaderProps {
  transparentHeader?: boolean;
}

export default memo(Header);
